module.exports = {"360704100":"梅林镇","360704101":"王母渡镇","360704102":"沙地镇","360704103":"江口镇","360704104":"田村镇","360704105":"南塘镇","360704106":"茅店镇","360704107":"吉埠镇","360704108":"五云镇","360704109":"湖江镇","360704110":"储潭镇","360704111":"韩坊镇","360704201":"阳埠乡","360704202":"大埠乡","360704203":"长洛乡","360704204":"大田乡","360704207":"石芫乡","360704208":"三溪乡","360704209":"白鹭乡","360704400":"江西赣县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360704.json
// module id = 1400
// module chunks = 0